import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
    resourceBody: {
        marginTop: '30px',
    },
    selectionSec: {
        display: 'flex',
        alignItems: 'center',
    },
    outlineButton: {
        marginRight: '10px',
        '& button': {
            fontSize: '12px',
            color: '#787878',
            border: '0.5px solid #787878',
            borderRadius: '4px',
            backgroundColor: 'transparent',
            padding: '4px 11px',
            cursor: 'pointer',
            textTransform: 'unset',
            fontFamily: 'Inter-Medium',
        },
    },
    newButton: {
        marginRight: '10px',
        '& button': {
            fontSize: '12px',
            color: '#fff',
            border: '1px solid #007DFF',
            borderRadius: '4px',
            backgroundColor: '#007DFF',
            padding: '3px 11px',
            cursor: 'pointer',
            textTransform: 'unset',
            fontFamily: 'Inter-Medium',
            '&:hover': {
                backgroundColor: '#007DFF !important',
            },
        },
    },
    tableSec: {
        marginTop: '30px',
        '& .ag-theme-alpine': {
            '&:nth-child(1)': {
                height: 'calc(100vh - 245px) !important',
            },
        },
    },
    opacityBlur: {
        opacity: '50%',
    },
    headerCont: {
        display: 'flex',
    },
}));
